import { axiosClient } from "./axiosClient"

export const ORDER_DETAILS_PATH = '/api/v1/order-details'

export const getAllOrderDetails = ({ orderId = "" }) => {
    return axiosClient.get(`${ORDER_DETAILS_PATH}/all?orderId=${orderId}`)
}

export const addOrderDetail = (body) => {
    return axiosClient.post(ORDER_DETAILS_PATH, body)
}

export const updateOrderDetail = (id, body) => {
    return axiosClient.put(`${ORDER_DETAILS_PATH}/${id}`, body)
}

export const deleteOrderDetail = (id) => {
    return axiosClient.delete(`${ORDER_DETAILS_PATH}/${id}`)
}

// export const getOrderById = (id) => {
//     return axiosClient.get(`${ORDER_PATH}/${id}`)
// }

// export const getPageOrders = ({ lastId = '', id = "", code = '', name = '' }) => {
//     return axiosClient.get(`${ORDER_PATH}/page?lastId=${lastId}&id=${id}&code=${code}&name=${name}`)
// }
